/*

commented out since products are in draft

function removeProduct() {
  let updates = {
    45600629555443: 0,
    45600630997235: 0,
    45600631030003: 0,
  };

  fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

window.addEventListener("pageshow", (event) => {
  if (event.persisted) {
    removeProduct();
  }
});

removeProduct();
*/

jQuery(document).ready(function ($) {
  function movePromoForMobile() {
    if ($(window).width() <= 767) {
      $(
        ".collection-travel-shoes .promotion-column-width--1.product-columns-5"
      ).insertAfter(".collection-travel-shoes .column.column-6");
    } else {
    }
  }

  // Initial call on page load
  movePromoForMobile();

  // Call again on resize
  $(window).resize(function () {
    movePromoForMobile();
  });
});

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "AW-873957181");

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

let scrollTimeout;

window.addEventListener("scroll", () => {
  // Save current scroll position to sessionStorage during scrolling
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    sessionStorage.setItem("scrollY", window.scrollY);
  }, 100); // Only save if user stops scrolling for 100ms
});

if (typeof CartDrawer !== "undefined") {
  let cartD = new CartDrawer();
  cartD.refresh();
}

document.addEventListener("rebuy:cart.add", function (event) {
  // Prevent Smart Cart auto-opening (again, just in case)
  event.preventDefault();

  // Open the pre-cart drawer upsell widget
  const preCartWidget = window.Rebuy.widgets?.find((w) => w.id === 112126);
  if (preCartWidget) {
    preCartWidget.node.classList.add("open"); // Show drawer via CSS
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 768) {
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains("thb-hover")) {
              node.classList.remove("thb-hover");
            }

            // Check descendants too
            node.querySelectorAll?.(".thb-hover")?.forEach((el) => {
              el.classList.remove("thb-hover");
            });
          }
        });

        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const el = mutation.target;
          if (el.classList.contains("thb-hover")) {
            el.classList.remove("thb-hover");
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    // Also remove existing ones on load
    document.querySelectorAll(".thb-hover").forEach((el) => {
      el.classList.remove("thb-hover");
    });
  }
});

jQuery(document).ready(function () {
  jQuery(".footer .thb-widget-title.collapsible").first().addClass("active");
  let userInteracted = false;

  function isInViewport(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  function sendCommandToIframe(iframe, command) {
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: command,
        args: [],
      }),
      "*"
    );
  }

  function ensureEnableJsApi(iframe) {
    if (!iframe.src.includes("enablejsapi=1")) {
      const separator = iframe.src.includes("?") ? "&" : "?";
      iframe.src += separator + "enablejsapi=1";
    }
  }

  function handleVideos() {
    jQuery(".prodesc_cont_video iframe, .match_video iframe").each(function () {
      const iframe = this;
      ensureEnableJsApi(iframe);

      if (isInViewport(iframe)) {
        sendCommandToIframe(iframe, "playVideo");
        if (userInteracted) {
          sendCommandToIframe(iframe, "mute");
        }
      } else {
        sendCommandToIframe(iframe, "pauseVideo");
      }
    });
  }

  // Detect first interaction
  jQuery(window).one("click scroll keydown", function () {
    userInteracted = true;
    handleVideos(); // Unmute if already in viewport
  });

  jQuery(window).on("scroll resize load", function () {
    handleVideos();
  });

  handleVideos();
});

document.addEventListener("DOMContentLoaded", function () {
  const drawerContent = document.getElementById("Product-Drawer-Content");
  if (!drawerContent) return;

  // Observe content append inside the drawer
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
        // When content is added to quick view, call logic
        initPreOrderLogic();
      }
    }
  });

  observer.observe(drawerContent, { childList: true, subtree: true });
});

function initPreOrderLogic() {
  const inventoryScript = document.querySelector(
    "#Product-Drawer-Content #ProductJson"
  );
  if (!inventoryScript) return;

  try {
    const inventoryData = JSON.parse(inventoryScript.textContent);
    const selectedWidthInput = document.querySelector(
      '#Product-Drawer-Content input[name="Width"]:checked'
    );
    if (!selectedWidthInput) return;

    const selectedWidth = selectedWidthInput.value;

    inventoryData.forEach((variant) => {
      const sizeInput = document.querySelector(
        `#Product-Drawer-Content input[name="Size"][value="${variant.option2}"]`
      );
      if (!sizeInput) return;
      if (
        variant.inventory_quantity === 0 &&
        selectedWidth === variant.option1
      ) {
        sizeInput.classList.add("preOrder");
      } else if (
        variant.inventory_quantity !== 0 &&
        selectedWidth === variant.option1
      ) {
        sizeInput.classList.remove("preOrder");
      }
    });

    // Attach width change listener inside drawer
    document
      .querySelectorAll('#Product-Drawer-Content input[name="Width"]')
      .forEach((Ele) => {
        Ele.addEventListener("change", function () {
          initPreOrderLogic();
        });
      });

    // Preorder button and delivery promise logic
    document
      .querySelectorAll("#Product-Drawer-Content input.variation-option-radio")
      .forEach((input) => {
        input.addEventListener("change", () => {
          setTimeout(() => {
            const deliveryPromise = document.querySelector(
              "#Product-Drawer-Content delivery-promise-wc"
            );
            const isPreOrder = document.querySelector(
              "#Product-Drawer-Content .restock-rocket-preorder-description"
            );
            const addToCartButton = document.querySelector(
              "#Product-Drawer-Content #AddToCart .single-add-to-cart-button--text"
            );

            if (isPreOrder) {
              if (addToCartButton)
                addToCartButton.textContent = "Preorder & Save 10%";
              if (deliveryPromise)
                deliveryPromise.classList.add("preOrderNone");
            } else if (deliveryPromise) {
              deliveryPromise.classList.remove("preOrderNone");
            }
          }, 500);
        });
      });
  } catch (e) {
    console.warn("Error parsing ProductJson inside drawer:", e);
  }
}

jQuery(document).on("change", ".variation-option-radio", function () {
  var selectedVariation = jQuery(this).val(); // Get the value of the selected variation
  localStorage.setItem("last_selected_variation", selectedVariation); // Store it in localStorage
  // Update the label for the selected variation
  var selectedVariationLabel = jQuery(this).next("label").text(); // Get the label text
  setTimeout(function () {
    if (document.querySelector(".restock-rocket-preorder-description")) {
      document.querySelector(
        "#AddToCart .single-add-to-cart-button--text"
      ).textContent = "Preorder & Save 10%";
      document
        .querySelector("delivery-promise-wc")?.classList.add("preOrderNone");
    }
  }, 1000);
  jQuery(this)
    .closest("fieldset")
    .find(".form__label__value")
    .text(selectedVariationLabel); // Update the label value
});

jQuery(document).ready(function () {
  const storedSize = localStorage.getItem("last_selected_variation");

  if (storedSize) {
    const $targetInput = jQuery(".variation-option-radio").filter(function () {
      return (
        jQuery(this).val() == storedSize &&
        !jQuery(this).hasClass("is-disabled")
      );
    });

    if ($targetInput.length) {
      $targetInput.prop("checked", true).trigger("click");

      // Trigger native Shopify variant logic
      $targetInput[0].dispatchEvent(new Event("change", { bubbles: true }));

      // Update the visual label
      const labelText = $targetInput.next("label").text();
      $targetInput
        .closest("fieldset")
        .find(".form__label__value")
        .text(labelText);
    }
  }
});

if (jQuery(window).width() <= 787.99) {
  jQuery(document).ready(function ($) {
    if (document.querySelector(".main-slider") !== null) {
      jQuery(".main-slider").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: ".slider-thumbs",
      });
      jQuery(".slider-thumbs").slick({
        infinite: false,
        mobileFirst: true,
        slidesToShow: 5,
        asNavFor: ".main-slider",
        dots: false,
        speed: 100,
        variableWidth: false,
        focusOnSelect: true,
        prevArrow:
          '<button type="button" class="slick-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0611/5852/3123/files/svgexport-11.svg?v=1723206366"></button>',
        nextArrow:
          '<button type="button" class="slick-next pull-right"><img src="https://cdn.shopify.com/s/files/1/0611/5852/3123/files/svgexport-12.svg?v=1723206366"></button>',
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
        ],
      });
      jQuery(".slick-slide:first-child").addClass("active");
      jQuery(".slider-thumbs").on("click", "img", function (event) {
        var currentIndex = parseInt(jQuery(".slider-counter--current").text());
        var targetIndex =
          parseInt($(this).parent("div").attr("data-slick-index")) +
          parseInt(1);
        if (currentIndex > targetIndex) {
          var click_cnt = currentIndex - targetIndex;
          var clickInterval = setInterval(() => {
            if (click_cnt <= 0) {
              clearInterval(clickInterval); // Stop the interval when done
            } else {
              jQuery("button.slider-button.slider-button--prev").click(); // Programmatically trigger a click event
              click_cnt--;
            }
          }, 300);
        }
        if (currentIndex < targetIndex) {
          var click_cnt = targetIndex - currentIndex;

          var clickInterval = setInterval(() => {
            if (click_cnt <= 0) {
              clearInterval(clickInterval); // Stop the interval when done
            } else {
              jQuery("button.slider-button.slider-button--next").click(); // Programmatically trigger a click event
              click_cnt--;
            }
          }, 300);
        }
      });
      jQuery(document).on("click", ".slick-prev", function () {
        jQuery(".slider-thumbs img").parent("div").removeClass("active");
        jQuery(".slider-thumbs .slick-current").addClass("active");
        jQuery("button.slider-button.slider-button--prev").click();
      });
      jQuery(document).on("click", ".slick-next", function () {
        jQuery(".slider-thumbs img").parent("div").removeClass("active");
        jQuery(".slider-thumbs .slick-current").addClass("active");
        jQuery("button.slider-button.slider-button--next").click();
      });
    }
  });
}

function attachProductEventListeners() {
  document
    .querySelectorAll(".colors-related li .product a")
    .forEach((element) => {
      // Avoid adding multiple listeners
      if (element.dataset.listenerAttached) return;
      element.dataset.listenerAttached = true;
      element.addEventListener("click", function (event) {
        const itemEl = element.closest("li.item");
        if (itemEl && itemEl.classList.contains("plus")) {
          return;
        }
        event.preventDefault();

        var prd_url = element.getAttribute("prd_url");
        var prd_title = element.getAttribute("title");
        var prd_simg =
          element.getAttribute("prd_simg")?.replace("_small", "") || "";
        var prd_img =
          element.getAttribute("prd_img")?.replace("_small", "") || "";

        element
          .closest(".colors-related")
          .querySelectorAll("li .product")
          .forEach((product) => {
            product.classList.remove("active");
          });

        element.closest(".product").classList.add("active");

        var pr_div = element.closest(".product-card-info");
        if (pr_div) {
          var divElement = pr_div.querySelector("a.product-card-title");
          if (divElement) {
            divElement.innerText = prd_title || "";
          }
        }

        var productCard = element.closest(".product-card");
        if (productCard) {
          var linkElement = productCard.querySelector(
            "figure.product-featured-image a.product-featured-image-link"
          );
          if (linkElement) linkElement.setAttribute("href", prd_url);

          var imgElement = productCard.querySelector(
            "img.product-primary-image"
          );
          if (imgElement) {
            imgElement.setAttribute("src", prd_img);
            imgElement.removeAttribute("srcset");
          }

          var hoverElement = productCard.querySelector("img.productHoverImg");
          if (hoverElement) hoverElement.setAttribute("src", prd_simg);
        }
      });
    });
}

// Use a MutationObserver to wait for .colors-related elements
const waitForColorsRelated = new MutationObserver((mutations, obs) => {
  if (document.querySelectorAll(".colors-related").length > 0) {
    // Attach listeners initially
    attachProductEventListeners();

    // Observe changes inside each .colors-related block
    document.querySelectorAll(".colors-related").forEach((targetNode) => {
      const sectionObserver = new MutationObserver((mutList) => {
        for (const mutation of mutList) {
          if (mutation.type === "childList") {
            setTimeout(() => attachProductEventListeners(), 100); // Slight delay to ensure DOM is ready
          }
        }
      });
      sectionObserver.observe(targetNode, { childList: true, subtree: true });
    });

    //obs.disconnect(); // Stop watching for .colors-related once found
  }
});

document.addEventListener("DOMContentLoaded", () => {
  waitForColorsRelated.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

var checkTimerDiv = document.querySelector(".ship-today b");
if (checkTimerDiv) {
  const COUNTDOWN_DURATION = 3 * 60 * 60 * 1000; // 3 hours in ms
  const STORAGE_KEY = "countdownStartTime";
  function getStartTime() {
    let startTime = localStorage.getItem(STORAGE_KEY);
    if (!startTime) {
      startTime = Date.now();
      localStorage.setItem(STORAGE_KEY, startTime);
    }
    return parseInt(startTime, 10);
  }
  function resetStartTime() {
    const newStartTime = Date.now();
    localStorage.setItem(STORAGE_KEY, newStartTime);
    return newStartTime;
  }
  function updateCountdown() {
    const countdownElem = document.querySelector(".ship-today b");
    let startTime = getStartTime();
    function tick() {
      const now = Date.now();
      let elapsed = now - startTime;
      let remaining = COUNTDOWN_DURATION - elapsed;
      if (remaining <= 0) {
        startTime = resetStartTime();
        remaining = COUNTDOWN_DURATION;
      }
      const hours = Math.floor(remaining / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      countdownElem.textContent =
        String(hours).padStart(2, "0") +
        ":" +
        String(minutes).padStart(2, "0") +
        ":" +
        String(seconds).padStart(2, "0");
    }
    tick();
    setInterval(tick, 1000);
  }
  updateCountdown();
}
